import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import Geometry from "@arcgis/core/geometry/Geometry";
import { TGeometry } from "../../../common/types/common";
import Polygon from "@arcgis/core/geometry/Polygon";
import { getSeparatedGeometries } from "../Map/helper";

export const getArea = (geometry: TGeometry | Geometry) => Math.abs(Math.round((geometryEngine as any).geodesicArea(geometry as unknown as Polygon, "acres") * 100)) / 100;
export const getEstimatedArea = (geometry) => {
  const separatedGeometries = getSeparatedGeometries(geometry);
  return getArea((geometryEngine as any).union(separatedGeometries as any as Geometry[]))
} 
